import { setAdmin, getAdmin } from '@/assets/js/util'
import { isData } from '@/assets/js/tools'

export default {
    state: {
        menu_nav: getAdmin('menu_nav') ? getAdmin('menu_nav') : 0,//顶部导航状态
        menu_left: getAdmin('menu_left') ? getAdmin('menu_left') : 0,//侧边导航
        menu_left_name: getAdmin('menu_left_name') ? getAdmin('menu_left_name') : 0,//侧边栏展开子项
        spinShow: false,//页面切换加载load
        pid: JSON.parse(getAdmin('pid')),//页面参数
        // web: '',//预览跳转地址
    },
    mutations: {
        setmenu(state, obj) {
            state[obj.key] = obj.val;
        }
    },
    getters: {

    },
    actions: {
        // 导航状态保存
        menu_type({ commit }, { key, data }) {
            var obj = {
                key: key,
                val: data
            }
            setAdmin(key, data)
            commit('setmenu', obj)
        }

    }
}



// WEBPACK FOOTER //
// ./src/store/module/app.js